import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const HTMLWrapper = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.colors.text};
  opacity: 0.9;
  line-height: 30px;
  font-weight: 500;
  white-space: normal;
  p,
  h1,
  h2,
  h3 {
    margin-bottom: 25px;
    white-space: normal;
  }
  h2 {
    font-weight: 700;
    font-size: 26px;
    white-space: normal;
  }
  li {
    margin-bottom: 20px;
    margin-left: 20px;
    white-space: normal;
  }
  a {
    color: ${(props) => props.theme.colors.text};
  }
  strong {
    font-weight: 700;
    opacity: 1;
  }
`

export const TextElem = styled(FocusNode)`
  height: 800px;
  padding-right: 20px;
  margin-bottom: 20px;
  overflow-y: auto;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  white-space: pre-line;
  &.isFocusedLeaf {
    box-shadow: none;
  }
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
  }

  &.isFocused::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.title};
  }
`
